import React from "react";
import css from "./event_modal.module.scss";
import { IconModalClose, IconCalendarMenu, IconTimeTable } from "re_redesigned_componnents/icon";

const LocationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const EventDetailModal = ({ open, onClose, eventData }) => {
  if (!open) return null;

  // Hardcoded data based on the user's image
  const data = eventData || {
    title: "Tech Summit 2026",
    subtitle: "Where innovation meets impact",
    category: "Conference",
    date: "June 12, 2026",
    time: "9:00 AM - 6:00 PM",
    location: "San Francisco, CA",
    description: "Join 5,000+ engineers, founders, and product leaders for two days of keynotes, hands-on workshops, and after-hours networking.",
    buttonText: "Reserve your spot"
  };

  return (
    <div className={css.overlay} onClick={onClose}>
      <div className={css.modal} onClick={(e) => e.stopPropagation()}>
        <div className={css.header}>
          <div className={css.badge}>{data.category}</div>
          <button className={css.closeBtn} onClick={onClose}>
            <IconModalClose />
          </button>
        </div>
        
        <div className={css.body}>
          <h1 className={css.title}>{data.title}</h1>
          <p className={css.subtitle}>{data.subtitle}</p>
          
          <div className={css.detailsCard}>
            <div className={css.detailItem}>
              <div className={css.iconBox}><IconCalendarMenu /></div>
              <span className={css.detailText}>{data.date}</span>
            </div>
            <div className={css.detailItem}>
              <div className={css.iconBox}><IconTimeTable /></div>
              <span className={css.detailText}>{data.time}</span>
            </div>
            <div className={css.detailItem}>
              <div className={css.iconBox}><LocationIcon /></div>
              <span className={css.detailText}>{data.location}</span>
            </div>
          </div>
          
          <p className={css.description}>{data.description}</p>
          
          <button className={css.reserveBtn}>{data.buttonText}</button>
        </div>
      </div>
    </div>
  );
};

export default EventDetailModal;
